import {Injectable} from '@angular/core';
import {
  Koeffiziente,
  ModellVariablenKoefficienteM2
} from 'shared/dtos/cockpit-kontrolle/modellvarianten-m2';

@Injectable({
  providedIn: 'root'
})
export class ModellvariantenM2KoeffizienteService {
  private readonly arrOfColumnNamesForM2 = [
    'analyseNurGrundlohn',
    'analyseFixeGewichtung',
    'standardAnalyseModell'
  ];

  getPreparateKoefficienteM2data(
    data: Koeffiziente
  ): ModellVariablenKoefficienteM2 {
    const result = new ModellVariablenKoefficienteM2();
    for (const key in result) {
      if (Object.prototype.hasOwnProperty.call(result, key)) {
        const element = result[key];
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (
          let index = 0;
          index < this.arrOfColumnNamesForM2.length;
          index++
        ) {
          const koefficientClmn = data[this.arrOfColumnNamesForM2[index]];
          element[this.arrOfColumnNamesForM2[index]] = koefficientClmn[key];
        }
      }
    }
    return result;
  }
}
